import { createThunkRoutine } from 'redux-thunk-routine';
import {
  CREATE_CUSTOMER,
  GET_CUSTOMERS,
  GET_ORGANIZATION_WITH_CUSTOMERS,
  GET_CUSTOMER_LICENSES,
  GET_CUSTOMER_USERS,
  GET_CUSTOMER_USERS_ROLES,
  GET_CUSTOMER_ACCOUNT_REPRESENTATIVES,
  GET_CUSTOMER_APPLICATIONS,
} from './action-types';
import type {
  IOrganizationCustomer,
  ICustomerShort,
  ICustomerUsersPayload,
  ICustomerUsersWithRolesResponse,
  ICustomerLicense,
  ICustomerApplication,
  TAccountRepresentative,
} from './interfaces';

export const CreateCustomerRoutine = createThunkRoutine<void>(CREATE_CUSTOMER);
export const GetOrganizationsWithCustomersRoutine = createThunkRoutine<IOrganizationCustomer[]>(GET_ORGANIZATION_WITH_CUSTOMERS);
export const GetCustomersRoutine = createThunkRoutine<ICustomerShort[]>(GET_CUSTOMERS);
export const GetCustomerUsersRoutine = createThunkRoutine<ICustomerUsersPayload>(GET_CUSTOMER_USERS);
export const GetCustomerUsersWithRoleRoutine = createThunkRoutine<ICustomerUsersWithRolesResponse>(GET_CUSTOMER_USERS_ROLES);
export const GetAccountRepresentativesRoutine = createThunkRoutine<TAccountRepresentative[]>(GET_CUSTOMER_ACCOUNT_REPRESENTATIVES);

export const GetCustomerLicensesRoutine = createThunkRoutine<ICustomerLicense[]>(GET_CUSTOMER_LICENSES);

export const GetCustomerApplicationsRoutine = createThunkRoutine<ICustomerApplication[]>(GET_CUSTOMER_APPLICATIONS);
